/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { NonNegativeInteger } from "@pagopa/ts-commons/lib/numbers";

// required attributes
const CreditorInstitutionViewR = t.interface({
  broker_code: t.string,

  creditor_institution_code: t.string,

  station_code: t.string
});

// optional attributes
const CreditorInstitutionViewO = t.partial({
  application_code: NonNegativeInteger,

  aux_digit: t.Integer,

  mod4: t.boolean,

  segregation_code: t.Integer,

  station_enabled: t.boolean
});

export const CreditorInstitutionView = t.intersection(
  [CreditorInstitutionViewR, CreditorInstitutionViewO],
  "CreditorInstitutionView"
);

export type CreditorInstitutionView = t.TypeOf<typeof CreditorInstitutionView>;
